/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserReportControllerGetCatalogsForExcel200ResponseDataCompaniesInner } from './userReportControllerGetCatalogsForExcel200ResponseDataCompaniesInner';


export interface UserReportControllerGetCatalogsForExcel200ResponseData { 
    companies?: Array<UserReportControllerGetCatalogsForExcel200ResponseDataCompaniesInner>;
    jobCategories?: Array<UserReportControllerGetCatalogsForExcel200ResponseDataCompaniesInner>;
    jobPositions?: Array<UserReportControllerGetCatalogsForExcel200ResponseDataCompaniesInner>;
    inactiveReasons?: Array<UserReportControllerGetCatalogsForExcel200ResponseDataCompaniesInner>;
}

